import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Heart,
  MessageCircle,
  Share2,
  Phone,
} from "lucide-react";
import "./FeedActions.css";

function FeedActions({
  item,
  setShowComments,
  setActivePost,
  onLike,
  onShare,
  onConsult,
}) {
  const navigate = useNavigate();
  const [likeAnimating, setLikeAnimating] = useState(false);

  /* ===============================
     OPEN CONSULT
  =============================== */
  const openContactProfessional = () => {
    if (!localStorage.getItem("token")) {
      navigate("/");
      return;
    }

    if (!item.user) {
      alert("Unable to contact this professional.");
      return;
    }

    onConsult?.(item.user);
  };

  const currentUser = JSON.parse(
    localStorage.getItem("civilink_user")
  );

  const isLiked = item.likes?.includes(currentUser?._id);

  /* ===============================
     LIKE ANIMATION
  =============================== */
  const handleLike = () => {
    setLikeAnimating(true);

    setTimeout(() => {
      setLikeAnimating(false);
    }, 400);

    onLike(item);
  };

  return (
    <div className="feed-actions">

      {/* LEFT ACTIONS */}
      <div className="feed-actions-left">

        {/* LIKE */}
        <button
          className={`feed-icon-action like-action ${
            isLiked ? "liked" : ""
          } ${likeAnimating ? "like-animate" : ""}`}
          onClick={handleLike}
          type="button"
          aria-label={isLiked ? "Unlike post" : "Like post"}
          title={isLiked ? "Unlike" : "Like"}
        >
          <Heart
            size={22}
            strokeWidth={2}
            fill={isLiked ? "currentColor" : "none"}
          />
        </button>

        {/* LIKE COUNT */}
        {item.likes?.length > 0 && (
          <span className="feed-like-count">
            {item.likes.length}
          </span>
        )}

        {/* COMMENT */}
        <button
          className="feed-icon-action"
          onClick={() => {
            setActivePost(item);
            setShowComments(true);
          }}
          type="button"
          aria-label="Comment on post"
          title="Comment"
        >
          <MessageCircle
            size={22}
            strokeWidth={2}
          />
        </button>

        {/* COMMENT COUNT */}
        {item.comments?.length > 0 && (
          <span className="feed-comment-count">
            {item.comments.length}
          </span>
        )}

        {/* SHARE */}
        <button
          className="feed-icon-action"
          onClick={onShare}
          type="button"
          aria-label="Share post"
          title="Share"
        >
          <Share2
            size={22}
            strokeWidth={2}
          />
        </button>

      </div>

      {/* CONSULT */}
      <button
        className="feed-consult-action"
        onClick={(e) => {
          e.stopPropagation();
          openContactProfessional();
        }}
        type="button"
        aria-label="Consult professional"
        title="Consult"
      >
        <Phone
          size={17}
          strokeWidth={2.2}
        />

        <span>Consult</span>
      </button>

    </div>
  );
}

export default FeedActions;